import { render } from "./CalculadoraComercialPage.vue?vue&type=template&id=940ecaf6"
import script from "./CalculadoraComercialPage.vue?vue&type=script&lang=js"
export * from "./CalculadoraComercialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__